function changeTeaType(event,type) {
    let sectionId = event.getAttribute('data-section');
    let collectionToToggle = event.getAttribute('data-block');
    let toggleToShow = document.querySelector(`[data-section-main="${sectionId}"] [data-tea-details="${collectionToToggle}"]`);
            
    document.querySelectorAll(`[data-section-main="${sectionId}"] [data-tea-toggle]`).forEach(element => {
        element.classList.remove('show-underline');
    });

    document.querySelectorAll(`[data-section-main="${sectionId}"] [data-tea-details]`).forEach(element => {
        element.classList.add('hidden');
        element.classList.remove('flex');
    });

    toggleToShow.classList.remove('hidden');
    toggleToShow.classList.add('animate-fadeup','flex');
    event.classList.add('show-underline');

    let collectionHandle = event.getAttribute('data-controls');
    if(type == 'click') {
        document.querySelector(`[data-section-main="${sectionId}"] select`).value = collectionHandle;
    }
    else {
        let buttonToSelect = document.querySelector(`[data-section-main="${sectionId}"] h4[data-controls="${collectionHandle}"]`);
        buttonToSelect.classList.add('show-underline');
    }
}

const allTeaToggles = document.querySelectorAll('[data-tea-toggle]');
const allTeaDropdowns = document.querySelectorAll('[data-tea-select]');

for(i=0; i< allTeaDropdowns.length; i++) {
    allTeaDropdowns[i].addEventListener('change', (event) => {
        let currentSelect = event.currentTarget;
        let selectedOption = currentSelect.options[currentSelect.selectedIndex];
        changeTeaType(selectedOption,'change');
    });   
}

for(i=0; i< allTeaToggles.length; i++) {
    allTeaToggles[i].addEventListener('click', (event) => {
        changeTeaType(event.currentTarget,'click');
    });   
}